export default __webpack_public_path__ + "static/media/1795.f7c08879.png";